var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-button",
    {
      staticClass: "button-item",
      style: _vm._buttonStyle,
      attrs: { loading: _vm.loading, disabled: _vm.disabled },
      on: { click: _vm._click },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }